import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3ZM16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM16.9933 10.8834C16.9355 10.386 16.5128 10 16 10C15.4477 10 15 10.4477 15 11V15H11L10.8834 15.0067C10.386 15.0645 10 15.4872 10 16C10 16.5523 10.4477 17 11 17H15V21L15.0067 21.1166C15.0645 21.614 15.4872 22 16 22C16.5523 22 17 21.5523 17 21V17H21L21.1166 16.9933C21.614 16.9355 22 16.5128 22 16C22 15.4477 21.5523 15 21 15H17V11L16.9933 10.8834Z"
	})
});
export default SvgPlusCircle;
